import { BaseIconProps } from "../../types/styles";

interface CopyIconProps extends BaseIconProps {
    isCopied: boolean;
}

const CopyIcon = ({
    id,
    className,
    size = 20,
    customColor,
    isCopied,
    ...rest
}: CopyIconProps) => {
    const color =
        customColor ?? (isCopied ? "var(--success-500)" : "var(--neutral-200)");

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-copy"}
            className={`${isCopied ? "" : "hover:stroke-neutral-400"} ${className ?? ""}`}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
            <path d="m9 14 2 2 4-4" className={isCopied ? "" : "opacity-0"} />
        </svg>
    );
};

export default CopyIcon;
